
import TopBar from "@/components/TopBar.vue";
import SideBar from "@/components/SideBar.vue";
import { defineComponent } from "@vue/composition-api";

export default defineComponent({
  components: {
    TopBar,
    SideBar,
  },
  data: () => ({
    alertVariant: "success",
    alertTime: 0,
    alertMessage: null,
    dismissSecs: 4,
  }),
  mounted() {
    this.$root.$on("showAlert", this.showAlert);
    this.reset();
  },
  methods: {
    alertTimeChanged(alertTime: number) {
      this.alertTime = alertTime;
    },
    reset() {
      this.alertVariant = "success";
      this.alertTime = 0;
      this.alertMessage = null;
      this.dismissSecs = 4;
    },
    showAlert(time: number, variant: string, msg: null) {
      this.alertTime = time;
      this.alertVariant = variant;
      this.alertMessage = msg;
    },
  },
});
